import * as Yup from "yup";

export interface UpdateInviteLinkUsageLimitFormFields {
  maxUsageLimit: number;
}

export interface UpdateInviteLinkUsageLimitFormBuilderParams {
  currentUsage: number;
}

export const buildUpdateInviteLinkUsageLimitFormSchema = ({
  currentUsage = 0,
}: UpdateInviteLinkUsageLimitFormBuilderParams): Yup.SchemaOf<UpdateInviteLinkUsageLimitFormFields> =>
  Yup.object({
    maxUsageLimit: Yup.number().required().min(currentUsage),
  }).required();
